import { c as _c } from "react/compiler-runtime";
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import useOnEnterOrSpacebar from 'hooks/useOnEnterOrSpacebar';
const RatioContainer = React.forwardRef((t0, ref) => {
  const $ = _c(13);
  const {
    children,
    className: t1,
    onClick,
    ratio: t2,
    wrapperClassName: t3
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const ratio = t2 === undefined ? 1 : t2;
  const wrapperClassName = t3 === undefined ? "" : t3;
  const innerElementRef = useRef(null);
  useOnEnterOrSpacebar(!!onClick, innerElementRef, onClick);
  const t4 = `h-0 overflow-hidden relative ${wrapperClassName}`;
  const t5 = `${100 * ratio}%`;
  let t6;
  if ($[0] !== t5) {
    t6 = {
      paddingTop: t5
    };
    $[0] = t5;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  const t7 = `h-full left-0 absolute top-0 w-full ${className}`;
  const t8 = onClick ? "button" : undefined;
  const t9 = onClick ? "0" : undefined;
  let t10;
  if ($[2] !== children || $[3] !== onClick || $[4] !== t7 || $[5] !== t8 || $[6] !== t9) {
    t10 = <div className={t7} onClick={onClick} role={t8} tabIndex={t9} ref={innerElementRef}>{children}</div>;
    $[2] = children;
    $[3] = onClick;
    $[4] = t7;
    $[5] = t8;
    $[6] = t9;
    $[7] = t10;
  } else {
    t10 = $[7];
  }
  let t11;
  if ($[8] !== ref || $[9] !== t10 || $[10] !== t4 || $[11] !== t6) {
    t11 = <div className={t4} style={t6} ref={ref}>{t10}</div>;
    $[8] = ref;
    $[9] = t10;
    $[10] = t4;
    $[11] = t6;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  return t11;
});
RatioContainer.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  onClick: PropTypes.func,
  ratio: PropTypes.number,
  wrapperClassName: PropTypes.string
};
export default RatioContainer;